import { isSameSymbol } from '@/entities/symbol';
import { MAX_TILES_LIMIT } from '@/features/Dashboard/constants/const';
import type { MarketApp, MarketApps, TileBigNumber } from '@/features/Dashboard/types';

export const getWidgetAnimationIds = (widget: MarketApp) => {
  if ('type' in widget) {
    return widget.tiles.map(tile => tile.id);
  }
  return [widget.id];
};

export const buildUpdatedTabContent = (
  currentTabContent: MarketApps,
  widget: MarketApp
): MarketApps => {
  if (!('type' in widget)) {
    return [...currentTabContent, widget] as MarketApps;
  }

  if (!currentTabContent[0] || !('type' in currentTabContent[0])) {
    return [widget, ...currentTabContent] as MarketApps;
  }

  const mergedContent: MarketApps = [];
  for (let i = 0; i < currentTabContent.length; i++) {
    const dashboardWidget = currentTabContent[i];
    if (i === 0 && 'tiles' in dashboardWidget) {
      const existingTiles = dashboardWidget.tiles;
      const existingSymbols = existingTiles.map(t => t.symbol.key);
      const newTiles: TileBigNumber[] = [];

      for (const tile of widget.tiles) {
        if (!existingSymbols.some(es => isSameSymbol(es, tile.symbol.key))) {
          newTiles.push(tile);
        }
      }

      const mergedTiles = [...existingTiles, ...newTiles].slice(0, MAX_TILES_LIMIT);
      mergedContent.push({ ...dashboardWidget, tiles: mergedTiles });
    } else {
      mergedContent.push(dashboardWidget);
    }
  }

  return mergedContent;
};
